import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import styles from './Link.module.scss';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  openNewTab?: boolean;
  className?: string;
  showExternalIcon?: boolean;
  onClick?: () => void;
  testId?: string;
  hidden?: boolean;
}

export const Link: React.FC<LinkProps> = ({
  href,
  children,
  openNewTab,
  showExternalIcon,
  className = '',
  onClick,
  testId,
  hidden,
  ...rest
}) => {
  const isExternal = href.startsWith('http');

  // eslint disabled for <a> (whines about target _blank needing noreferrer, but it always will)

  if (isExternal && href) {
    return (
      <a  // eslint-disable-line
        href={href}
        target={openNewTab ? '_blank' : '_self'}
        rel={openNewTab ? 'noreferrer' : undefined}
        className={`${className} ${styles.Link}`}
        draggable={false}
        onClick={onClick}
        data-testid={testId}
        aria-hidden={hidden}
        tabIndex={hidden ? -1 : undefined}
        {...rest}
      >
        {children}
        {showExternalIcon && <i style={{ fontSize: '0.9em', fontWeight: 'bold' }} className="mm-external-link" />}
      </a>
    );
  }

  return (
    <RouterLink
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : undefined}
      draggable={false}
      to={href}
      className={className}
      onClick={onClick}
      data-testid={testId}
      {...rest}
    >
      {children}
    </RouterLink>
  );
};
